<template>
    <div v-if="city" class="oak-next-root">
        <div class="oak-next-banner">
            <v-btn
                icon
                class="oak-next-back-btn"
                :disabled="isLoading"
                @click="backToCity"
            >
                <v-icon color="white">mdi-arrow-left</v-icon>
            </v-btn>
            <span class="oak-next-title-pill">{{ $t('journey.oakNext.title') }}</span>
        </div>
        <div class="oak-next-content">
            <OakTable :trainer-id="trainerId"/>
        </div>
    </div>
</template>

<script>
    // Záložní cesta pro position.type OAK (starý svět) - běžný flow místo
    // toho otevírá OakDialog popup přímo z CityNext, bez přechodu do OAK.
    import * as journeyApi from '@/api/journeyApi';
    import {mapActions, mapGetters} from 'vuex';
    import OakTable from './pieces/OakTable';

    export default {
        name: 'OakNext',
        components: {OakTable},
        props: {
            city: {type: Object, default: null},
            position: {type: Object, default: null},
            trainerId: {type: Number, default: null},
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
            }),
        },
        methods: {
            ...mapActions({
                positionPost: 'journey/positionPost',
            }),
            backToCity() {
                this.positionPost(journeyApi.travel(this.position.id, this.city.id));
            },
        },
    }
</script>

<style scoped>
.oak-next-root {
    height: 100%;
    overflow: auto;
    background: #F5F5F5;
    padding-bottom: 54px;
}
.oak-next-banner {
    position: relative;
    height: 150px;
    background-image: url('@/assets/pic/web/oak.png');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 10px;
}
.oak-next-title-pill {
    display: inline-block;
    background: rgba(0,0,0,0.65);
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    padding: 6px 24px;
    border-radius: 20px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
}
.oak-next-back-btn {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
    background: rgba(0,0,0,0.5) !important;
}
.oak-next-content {
    padding: 12px;
}
</style>
